import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { sessionStorage as amplifySessionStorage } from "aws-amplify/utils";
import AmplifyVue from "@aws-amplify/ui-vue";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import SetInterval from '@/plugins/SetInterval';
import DatePickerScroll from '@/plugins/DatePickerScroll';
import IdleTimeout from '@/plugins/IdleTimeout';
import vuetify from "./plugins/vuetify";

// FontAwesome設定
dom.watch();
library.add(fas, fab, far);

// AWS Amplify 設定
const host = window.location.host;
const parts = host.split(".");
// サブドメインの「-」を「_」に変換し、大文字化して環境変数キーを組み立てる
const envKeySuffix = parts[0].replace(/-/g, "_").toUpperCase();
const userId = "VITE_AWS_COGNITO_USER_POOL_ID_" + envKeySuffix;
const clientId =
  "VITE_AWS_COGNITO_USER_POOL_CLIENT_ID_" + envKeySuffix;

// セッションタイプ設定（review側の機能を追加）
// sessionType が "discard" の場合、sessionStorage を使用してブラウザを閉じたらログアウト
const sessionTypeKey = "VITE_AWS_SESSION_TYPE_" + envKeySuffix;
const sessionType = (import.meta.env[sessionTypeKey] ?? "").toLowerCase();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:
        import.meta.env[userId] ??
        import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID_DEFAULT!,
      userPoolClientId:
        import.meta.env[clientId] ??
        import.meta.env.VITE_AWS_COGNITO_USER_POOL_CLIENT_ID_DEFAULT!,
      identityPoolId: "",
      allowGuestAccess: false,
    },
  },
});

// AWS Amplify v6では、sessionStorageを使用する場合はcognitoUserPoolsTokenProviderを使用
// Amplify.configure()の後に呼び出す必要がある
// aws-amplify/utilsからインポートしたsessionStorageを使用することで、
// ブラウザを閉じた際にログインセッションが破棄される
if (sessionType === "discard") {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(amplifySessionStorage);
}

const app = createApp(App);
app.use(vuetify);
app.use(router);
app.use(store);
app.use(AmplifyVue);
app.use(SetInterval);
app.use(DatePickerScroll);
app.use(IdleTimeout);

// グローバルコンポーネント
app.component("FontAwesomeIcon", FontAwesomeIcon);

// カスタム要素無視設定（Amplify UI のタグを残す）
app.config.compilerOptions.isCustomElement = (tag) =>
  tag.startsWith("amplify-");

app.mount("#app");
